export default [
  {
    value: "Tree",
    label: "古树"
  },
  {
    value: "TreeGroup",
    label: "古树群"
  }
];
